import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Button, Grid, Typography, Box, Hidden, IconButton } from '@mui/material';
import { PersonAdd as IconPersonAdd, Search as IconSearch
    , IndeterminateCheckBox as IconIndeterminateCheckBox, CheckBox as IconCheckBox
    , Delete as IconDelete } from "@mui/icons-material";
import { Link } from "react-router-dom";
import * as evaluacionService from "../../services/evaluacionService";
import DataGridBase from "../../components/common/DataGridBase";
import DialogYesNo from '../../components/DialogYesNo';

// Navegabilidad de temas de evaluacion: el catalogo jerarquico. Los grupos
// (tema padre) y sus temas se ven en una sola lista, con el grupo al lado.
const Index = () => {
    const [results, setResults] = useState([]);
    const [cargando, setCargando] = useState(true);
    const [openDialogDelete, setOpenDialogDelete] = useState(false);
    const [selectId, setSelectId] = useState(null);
    const navigate = useNavigate();

    const fetchResults = useCallback(async () => {
        setCargando(true);

        await evaluacionService.getsTemaEvaluacionView()
            .then((data) => {
                // Los grupos primero, y debajo sus temas.
                const grupos = (data || []).filter((row) => row.idTemaPadre == null);
                const temas = (data || []).filter((row) => row.idTemaPadre != null);

                const lista = [];

                grupos.forEach((grupo) => {
                    lista.push(grupo);

                    temas
                        .filter((tema) => tema.idTemaPadre == grupo.id)
                        .sort((a, b) => (a.orden || 0) - (b.orden || 0))
                        .forEach((tema) => lista.push(tema));
                });

                setResults(lista);
                setCargando(false);
            })
            .catch((err) => {
                setCargando(false);
                console.log("Err: ", err);
            });
    }, [])

    useEffect(() => {
        fetchResults();
    }, [fetchResults])

    const deleteEntity = async () => {
        await evaluacionService.deleteTemaEvaluacion(selectId)
            .catch((err) => {
                console.log("Err: ", err);
            });
        fetchResults();
    }

    const columnas = useMemo(() => [
        { field: 'id', headerName: 'ID', width: 50, minWidth: 45, sortable: true, headerAlign: 'center', align: 'center',
            renderCell: (p) => <span style={{ fontSize: '0.75rem', color: '#666', fontFamily: 'monospace' }}>{p.value != null ? p.value : p.row.id}</span> },
        { field: 'nombre', headerName: 'Nombre', width: 240, sortable: false, headerAlign: 'center'
            , renderCell: (cellValues) => {
                const esGrupo = cellValues.row.idTemaPadre == null;

                return (
                    <Link to={'/evaluacion/temas/edit/' + cellValues.row.id}
                        style={{ color: 'inherit', fontWeight: esGrupo ? 'bold' : 'normal', paddingLeft: esGrupo ? 0 : 24 }}>
                        {cellValues.row.nombre}
                    </Link>
                );
            }
        },
        { field: 'temaPadre', headerName: 'Grupo', width: 200, sortable: false, headerAlign: 'center' },
        { field: 'orden', headerName: 'Orden', width: 90, sortable: false, headerAlign: 'center', align: 'center' },
        { field: 'cantidadObjetivos', headerName: 'Objetivos', width: 110, sortable: false, headerAlign: 'center', align: 'center' },
        { field: 'cantidadSubtemas', headerName: 'Subtemas', width: 110, sortable: false, headerAlign: 'center', align: 'center' },
        { field: 'estado', headerName: 'Estado', width: 100, sortable: false, headerAlign: 'center', align: 'center' },
        { field: 'delete', headerName: '', width: 80, sortable: false, headerAlign: 'center', align: 'center'
            , renderCell: (cellValues) => {
                return <IconButton aria-label="delete" size='small' style={{ height: 10 }} align={"center"} onClick={() => {
                    setSelectId(cellValues.row.id);
                    setOpenDialogDelete(true);
                }}>
                    <IconDelete />
                </IconButton>;
            }
        },
    ], [])

    return (
        <div>
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                        Temas de Evaluacion
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <Box sx={{ display: 'grid', gridTemplateColumns: '1fr' }}>
                        <DataGridBase
                            rows={results}
                            columns={columnas}
                            loading={cargando}
                            toolbarButtons={[
                                {
                                    text: "NUEVO",
                                    icon: <IconPersonAdd />,
                                    onClick: () => navigate("/evaluacion/temas/edit/0")
                                }
                            ]}
                        />
                    </Box>
                </Grid>
                <DialogYesNo open={openDialogDelete} openClose={() => { setOpenDialogDelete(!openDialogDelete) }} setYes={deleteEntity}
                    setNo={() => { return }}
                    titulo={"Borrar Tema"}
                    texto={"Esta seguro de borrar el tema?"} >
                </DialogYesNo>
            </Grid>
        </div>
    )
}

export default Index;
